import edapWrapper from '@homeaway/edap-wrapper';

const GENERIC_EVENT = 'generic.event';
const PAGE_MODULE_VIEW = 'page.module.view';
const CONTENT_MODULE_PRESENTED = 'content_module.presented';
const SEARCH_QUERY_SUBMITTED = 'search_query.submitted';
const SEARCH_LINK_CLICK = 'search.link.click';
const GUESTPICKER_PRESENTED = 'guestpicker.presented';
const GUEST_SELECTOR_UPDATE = 'guest_selector_update.selected';
const GUEST_UPDATE = 'guest_update.submitted';

function getActionLocation(edapActionLocation) {
    return `${edapActionLocation}-dated-search-modal`;
}

function getBaseEventData(edapActionLocation, edapEventRefinements) {
    return {
        actionlocation: getActionLocation(edapActionLocation),
        eventrefinements: edapEventRefinements,
    };
}

/**
 * Function to send evants with the correct property names: eg. action_location instead of actionlocation
 * The reason behind it is the way events are configured with fast track
 *
 * @param {} edapEventRefinements
 * @param {*} name
 * @param {*} data
 * @param {*} eventrefinements
 */
function sendEdapEventFastTrack(edapActionLocation, name, data = {}) {
    edapWrapper().push({
        name,
        data: {
            action_location: getActionLocation(edapActionLocation),
            ...data,
        },
    });
}

export {
    getActionLocation,
    getBaseEventData,
    sendEdapEventFastTrack,
    GENERIC_EVENT,
    PAGE_MODULE_VIEW,
    CONTENT_MODULE_PRESENTED,
    SEARCH_QUERY_SUBMITTED,
    SEARCH_LINK_CLICK,
    GUESTPICKER_PRESENTED,
    GUEST_SELECTOR_UPDATE,
    GUEST_UPDATE,
};
